import { useServiceTypePlace } from '@church/data'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { PlansPanel } from '../components/services/ServicesPanels.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'
import { folderCrumbs } from '../lib/services-crumbs.ts'

/** One service type's plans. */
export const Route = createFileRoute('/_authed/_shell/services/_sections/types/$typeId')({
  // `all` was every service's plans at once, since retired: it lands on Plans.
  beforeLoad: ({ params }) => {
    if (params.typeId === 'all') throw redirect({ to: '/services/plans', replace: true })
  },
  component: ServiceTypeScreen,
})

function ServiceTypeScreen() {
  const { typeId } = Route.useParams()
  const navigate = useNavigate()
  const place = useServiceTypePlace(typeId)
  // Plans › Main campus › Youth › Youth Night: the way back up its folders.
  useBreadcrumbs([
    ...folderCrumbs(place.folders),
    { label: place.type?.name ?? 'Service' },
  ])
  return (
    <PlansPanel
      typeId={typeId}
      setTypeId={(next) =>
        void navigate({ to: '/services/types/$typeId', params: { typeId: next } })
      }
    />
  )
}
